<template>
  <div v-if="!loading">
    <v-card class="mt-8 mx-8 pa-4">
      <v-card-title>نمایش اساتید</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="12" md="3" lg="3">
            <v-select color="black" v-model="order" label="نوع ترتیب کاربران را انتخاب کنید" :items="orderItems"
                      item-text="name" @change="getTeachers"></v-select>
          </v-col>
          <v-col cols="12" sm="12" md="9" lg="9" class="text-left">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="hover-link mx-1"
                        color="teal"
                        v-bind="attrs"
                        v-on="on" @click="$router.push('/teachers/setting')">mdi-cog
                </v-icon>
              </template>
              <span class="tooltip-text">تنظیمات اساتید</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon x-large class="hover-link mx-1"
                        color="success"
                        v-bind="attrs"
                        v-on="on" @click="$router.push('/teachers/create')">mdi-plus
                </v-icon>
              </template>
              <span class="tooltip-text">ساخت استاد جدید</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12">
            <v-data-table
                align="center"
                :headers="headers"
                :items="teachers.data"
                :items-per-page="10"
                disable-sort
                hide-default-footer>
              <template
                  v-slot:[`item.profile_image`]="{ item }">
                <v-img :src="item.profile_image" width="70" height="60" class="mr-16"></v-img>
              </template>
              <template
                  v-slot:[`item.operation`]="{ item }">
                <v-icon class="mx-1" color="purple" @click="$router.push('/teachers/edit/'+item.id)">mdi-pen</v-icon>
                <v-icon class="mx-1" color="error" @click="destroy(item.id)">mdi-trash-can-outline</v-icon>
              </template>
            </v-data-table>
          </v-col>
          <v-col cols="12">
            <v-pagination
                class="text-center"
                color="#696CFF"
                v-model="teachers.current_page"
                :length="teachers.last_page"
                circle
                @input="getTeachers"
            ></v-pagination>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="deleteDialog" max-width="50vw">
      <v-card class="ma-0">
        <v-row class="ma-0">
          <v-col cols="12">
            آیا از حذف این مربی اطمینان دارید؟
          </v-col>
          <v-col cols="6">
            <v-btn color="warning" @click="finalDestroy">
              بله
            </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn color="success" @click="deleteDialog=false">
              خیر
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "TeacherIndex",
  data() {
    return {
      selectedEntityId: null,
      deleteDialog: false,
      loading: true,
      orderItems: [
        {name: 'بر اساس وضعیت', value: 'status'},
        {name: 'بر اساس جنسیت', value: 'gender'},
        {name: 'بر اساس تاریخ ثبت نام', value: 'created_at'},
      ],
      order: 'created_at',
      teachers: {
        current_page: 1
      },
      headers: [
        {text: 'شناسه', value: 'id', align: 'center'},
        {text: 'نام', value: 'name', align: 'center'},
        {text: 'آخرین فعالیت', value: 'last_visit_fa', align: 'center'},
        {text: 'ایمیل', value: 'email', align: 'center'},
        {text: 'تاریخ ثبت نام', value: 'register_date_fa', align: 'center'},
        {text: 'جنسیت', value: 'gender_label', align: 'center'},
        {text: 'شماره همراه', value: 'mobile', align: 'center'},
        {text: 'عکس پروفایل', value: 'profile_image', align: 'center'},
        {text: 'استان', value: 'state_name', align: 'center'},
        {text: 'شهر', value: 'city_name', align: 'center'},
        {text: 'مدرسه', value: 'school_label', align: 'center'},
        {text: 'وضعیت', value: 'status_label', align: 'center'},
        {text: 'کنترل', value: 'operation', align: 'center'},
      ],
    }
  },
  mounted() {
    this.getTeachers()
  },
  methods: {
    finalDestroy() {
      window.axios.delete('admin/instructor/delete/' + this.selectedEntityId).then(() => {
        this.getTeachers()
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      }).finally(() => {
        this.deleteDialog = false
      })
    },
    getTeachers() {
      let url = 'admin/instructor/index?page=' + this.teachers.current_page ?? 1
      url = url + '&order=' + this.order
      window.axios.get(url).then((res) => {
        this.teachers = res.data.data
        this.loading = false
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    },
    destroy(teacherId) {
      this.selectedEntityId = teacherId
      this.deleteDialog = true
    }

  }
}
</script>

<style scoped>

</style>